import { IStepProps } from '../../../pages/Sign-Up/UserDetailsForm';
import StepHeader from '../../../pages/Organization/public/Journal/SubmissionUpload/components/StepHeader';
import { Flex } from '@chakra-ui/react';

import { useCallback, useEffect } from 'react';
import {
  IUserDetailsStepThreeForm,
  scrollToError,
  useUserDetailsData
} from './signupHook';
import ResearchFocusAndExpertise from './ResearchFocusAndExpertise';
import { useFormContext } from 'react-hook-form';

export type CustomErrorMessage = {
  dateOfBirth?: string;
  availableFrom?: string;
  availableUntil?: string;
  orcid?: boolean;
};

const StepThree = ({ currentStep, totalSteps, user }: IStepProps) => {
  const {
    formState: { errors }
  } = useFormContext<IUserDetailsStepThreeForm>();
  const {
    configs,
    isLoading: isDataLoading,
    isSuccess: isDataSuccess
  } = useUserDetailsData(user?.organizationId || '');

  const newConfig = {
    UnavailabilityPeriod: configs.UnavailabilityPeriod,
    UnavailabilityPeriodFrom: configs.UnavailabilityPeriodFrom,
    UnavailabilityPeriodTo: configs.UnavailabilityPeriodTo,
    ReviewerInterest: configs.ReviewerInterest,
    Specialty: configs.Specialty,
    SubSpecialty: configs.SubSpecialty,
    Keyword: configs.Keyword,
    ProfessionalInterests: configs.ProfessionalInterests
  };

  const scrollToFirstError = useCallback(() => {
    scrollToError(errors);
  }, []);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      setTimeout(scrollToFirstError, 100);
    }
  }, [errors, scrollToFirstError]);

  useEffect(() => {
    if (configs && isDataSuccess) {
      window.scrollTo({ top: 0 });
    }
  }, [configs, isDataLoading, isDataSuccess]);

  return (
    <Flex direction={'column'} mb={10} px={6} width={'full'} id="UserDetails">
      <StepHeader
        currentStep={currentStep}
        totalSteps={totalSteps}
        heading="Research Interest"
        description="Add more information to enhance your profile."
      />
      <Flex direction="column" gap={6}>
        <ResearchFocusAndExpertise configs={newConfig} />
      </Flex>
    </Flex>
  );
};

export default StepThree;